import api from './api';

class InvoiceService {
	async create(invoiceForm) {
		return api
			.post('/invoices', invoiceForm)
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log('fail when trying create a new invoice.', error.response?.data?.error);
				throw error.response?.data?.error;
			});
	}

	async syncronizeStatusWithIUGU(invoice) {
		return api
			.post('/invoices/syncronize/status/with/iugu', { invoice })
			.then((response) => response.data)
			.catch((error) => {
				console.log('fail when trying syncronize');
				throw error.response?.data?.error;
			});
	}

	async secondInvoice({ status, providerKey }) {
		return api
			.post('/invoices/second-invoice', { status, providerKey })
			.then((response) => response.data)
			.catch((error) => {
				console.log('fail when trying to generate second copy of invoice.', error.response?.data?.error);
				throw error.response?.data?.error;
			});
	}

	async getById(id) {
		return api
			.get(`/invoices/${id}`)
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log('fail when trying to fetch invoice by ID.', error.response?.data?.error);
				throw error.response?.data?.error;
			});
	}

	async syncronizeClientsInvoicesWithIUGU(clientId) {
		return api
			.post('/invoices/syncronize/clients/iugu', { clientId })
			.then((response) => response.data)
			.catch((error) => {
				console.log('fail when trying to syncronize client invoices', error.response?.data);
				throw error.response?.data?.error || error;
			});
	}

	async getInvoicesByEntity({ subscriptionId, contractId, page = 0, size = 10, statusFilter = null, clientId }) {
		const params = { page, size };
		if (subscriptionId) params.subscriptionId = subscriptionId;
		if (contractId) params.contractId = contractId;
		if (clientId) params.clientId = clientId;
		if (statusFilter) params.statusFilter = statusFilter;

		return api
			.get('/invoices/by-entity', { params })
			.then((response) => response.data)
			.catch((error) => {
				console.log(
					'fail when trying to get invoices by entity in InvoiceService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error || error;
			});
	}

	async getByClientLastContract(clientId, { page = 0, size = 10, statusFilter = null } = {}) {
		const params = { page, size };
		if (statusFilter) params.statusFilter = statusFilter;

		return api
			.get(`/invoices/client/${clientId}/last-contract`, { params })
			.then((response) => response.data)
			.catch((error) => {
				console.log(
					'fail when trying to get invoices by client last contract in InvoiceService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error || error;
			});
	}
}



const invoiceService = new InvoiceService();
export default invoiceService;
